module.exports = __webpack_public_path__ + "static/media/15.29886510.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/shirts/15.png
// module id = 1453
// module chunks = 0